import { ValidatorFn } from '@angular/forms';

export class Validator {

    public name: string;
    public validator: ValidatorFn;
    public parameters;
    public message: string;

    constructor(name: string, validator: ValidatorFn, message?: string, parameters?) {
        this.name       = name;
        this.validator  = validator;
        this.message    = message.length > 0 ? message : null;
        this.parameters = parameters;
    }

    public getValidatorFn(parameters?: any) {
        if (this.parameters) {
            return this.validator(parameters);
        } else {
            return this.validator;
        }
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/forms/form/models/validator.model.ts